<style lang="scss">
  @use "../../../../assets/css/global.scss" as *;
  @use "../../../../assets/css/_colors.scss" as *;
  .searchInputWrapper {
    display: flex;
    align-items: center;
    position: relative;
    height: 100%;

    .searchInput {
      flex: 1;
      border: 1.5px solid $light-gray;
      border-radius: 0.375rem;
      font-weight: 400;
      padding: 0.5rem 0.75rem;

      @extend .text-body-2;

      &:hover {
        border-color: $gray;
      }

      &:focus {
        box-shadow: none;
        border-color: $primary-color;
        outline-style: none;
      }

      &.showDeleteBtn {
        padding-right: 2.3rem;
      }
    }

    &.searchIcon {
      &::before {
        content: "\f002";
        font-family: "Font Awesome 6 Pro";
        font-size: 1rem;
        right: 1rem;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .deleteBtn {
      right: 0.6rem;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: none;
      border: none;
      font-size: 1.35rem;
      cursor: pointer;
      color: $text-gray;
    }
  }
</style>

<script>
  export let value = "";
  export let searchIcon = false;
  export let showDelete = false;
  export let placeholder = "Search";
  export let onInput = () => {};
  export let onDelete = () => {};
  export let style = "";
  export let preventDefaultEsc = false;

  let inputElement;

  const handleDelete = () => {
    onDelete();
  };

  const handleKeyDown = (e) => {
    if (preventDefaultEsc && e.key === "Escape") {
      e.preventDefault();
      inputElement.blur();
    }
  };

  $: showDeleteBtn = !searchIcon && showDelete;
</script>

<div class="searchInputWrapper" class:searchIcon {style}>
  <input
    bind:this={inputElement}
    bind:value
    class="searchInput"
    class:showDeleteBtn
    type="search"
    {placeholder}
    on:input={onInput}
    on:keydown={handleKeyDown}
  />
  {#if showDeleteBtn}
    <button class="deleteBtn" on:click={handleDelete} aria-label="Delete">
      <i class="fas fa-times"></i>
    </button>
  {/if}
</div>
